import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AdminBaseEditComponent } from 'src/modules/sm-base/components/admin-base-edit/admin-base-edit.component';
import { FrontendField } from 'src/modules/sm-base/netgen/FrontendField';
import { FrontendFieldType } from 'src/modules/sm-base/netgen/FrontendFieldType';
import { FrontendForm } from 'src/modules/sm-base/netgen/FrontendForm';
import { Utils } from 'src/modules/utils/shared/utils';
import { ProjectPlanningTools } from '../../models/project-planning-tools.model';
import { ResourceType } from '../../netgen/ResourceType';

@Component({
    selector: 'app-edit-resource-type',
    templateUrl: '../../../sm-base/components/admin-base-edit/admin-base-edit.component.html',
    styleUrl: '../../../sm-base/components/admin-base-edit/admin-base-edit.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditResourceTypeComponent extends AdminBaseEditComponent<ResourceType> {

    definition = ProjectPlanningTools.definitionResourceType;

    getForm(): FrontendForm {
        return this.app.tForm("entity.ResourceType.fields", new FrontendForm([
            new FrontendField("title", "", FrontendFieldType.string, { mandatory: true }),
            new FrontendField("color", "", FrontendFieldType.color, { predefinedColors: Utils.getMaterialColors()})                            
        ]));
    }
    
}
